import React from 'react';
import { IActionBarProps, ActionsBar } from 'components/ActionsBar/ActionsBar';
import './PrimaryActions.less';

export function PrimaryActions(props: IActionBarProps) {
  const actionBarProps = {
    ...props,
    actionClassName: 'dp-button normal',
  };

  return (
    <div className="dpc-primary-entitydetails-actions">
      <ActionsBar {...actionBarProps} />
    </div>
  );
}
